import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';


@Injectable()
export class LivestocktypeEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadLive(token, ID) {

		return this.http
		.get(this.apiUrl + "livestocktype/v1/getcodlivestocktype/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editLive(token, live: any) {

		return this.http
		.put(this.apiUrl + "livestocktype/v1/updatelivestocktype", live, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/livestocktype/service/livestocktype-edit/livestocktype-edit.service.ts